import { createSnapshotConsumer } from '@highlight/ipc'
import * as Sentry from '@sentry/electron/renderer'
import {
  EMPTY_MEETING_PARTICIPANTS_SNAPSHOT,
  MEETING_PARTICIPANTS_TOPIC,
  type MeetingParticipantsSnapshot,
  type TrackedParticipant,
} from '@shared/types/meeting-participant'

export const meetingParticipantsConsumer = createSnapshotConsumer<MeetingParticipantsSnapshot>({
  topic: MEETING_PARTICIPANTS_TOPIC,
  initialSnapshot: EMPTY_MEETING_PARTICIPANTS_SNAPSHOT,
  onError: (error) => {
    Sentry.captureException(error)
  },
})

export function getMeetingParticipants(): Record<number, TrackedParticipant> {
  return meetingParticipantsConsumer.getSnapshot().participants
}

export function subscribeToMeetingParticipants(listener: () => void): () => void {
  return meetingParticipantsConsumer.subscribe(listener)
}
